import { Component, DestroyRef, inject  } from '@angular/core';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TabViewChangeEvent, TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { BaseState } from '../../reducers';
import { Store } from '@ngrx/store';
import { savePng, saveZip } from '../store/editor.actions';
import { EventEmitter } from 'stream';
import { Subject, delay, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-export-dialog',
  standalone: true,
  imports: [DynamicDialogModule, TabViewModule, InputTextModule, FloatLabelModule, FormsModule, ButtonModule, CheckboxModule],
  templateUrl: './export-dialog.component.html',
  styleUrl: './export-dialog.component.scss'
})
export class ExportDialogComponent {
  fileName: string = "output.png"
  filterContext: boolean = false
  destroyRef = inject(DestroyRef)

  saving = false
  saveSuccess = new Subject<void>()
  mode: 'png' | 'zip' = "png"

  constructor(private dialog: DynamicDialogRef, private store: Store<BaseState>){}

  onTabChange(event: TabViewChangeEvent){
    switch(event.index) {
      case 0: {
        this.mode = 'png'
        this.fileName = 'output.png'
        break
      }
      case 1: {
        this.mode = 'zip'
        this.fileName = 'output.zip'
        break
      }

    }
  }

  closeDialog(){
    this.dialog.close()
  }

  saveZip() {
    this.store.dispatch(
      saveZip({filename: this.fileName, saveSuccess: () => this.saveSuccess.next()})
    )
  }

  savePng(){
    this.store.dispatch(
      savePng({filename: this.fileName, saveSuccess: () => this.saveSuccess.next()})
    )
  }

  save() {
    this.saving = true
    this.saveSuccess.pipe(
      delay(700),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(x => this.closeDialog())

    switch(this.mode) {
      case 'png': {
        console.log("testing")
        this.savePng()
        break
      }
      case 'zip': {
        this.saveZip()
        break
      }
    }
  }
}
